import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";

const CreateVehicle = () => {

    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [form, setForm] = useState({
        vehicle_number: "",
        lorry_type: "",
        capacity: ""
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: name === "vehicle_number"
                ? value.toUpperCase()
                : value
        });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/vehicle/create.php",
            data: form
        });

        if (res.success) {
            toast.success(res.message);
            setTimeout(() => reloadWindowToPath("/vehicles"), 1000);
        } else {
            toast.error(res.message);
        }

        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">

            <div className="page-header">
                <h4>Create Vehicle</h4>
            </div>

            <form onSubmit={handleSubmit} className="form-grid">

                <div className="form-group">
                    <label>Vehicle Number</label>
                    <input
                        name="vehicle_number"
                        className="form-control"
                        placeholder="Enter vehicle plate number (e.g. SGX1234A)"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Lorry Type</label>
                    <input
                        name="lorry_type"
                        className="form-control"
                        placeholder="Enter lorry type (e.g. 10 Ton, Trailer)"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Capacity</label>
                    <input
                        name="capacity"
                        className="form-control"
                        placeholder="Enter capacity (e.g. 5000kg)"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add" disabled={loading}>
                        {loading
                            ? (<><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>)
                            : "Create Vehicle"}
                    </button>
                </div>

            </form>
        </div>
    );
};

export default CreateVehicle;
